export default __webpack_public_path__ + "static/media/DSC06113.c702e41e.jpg";